import strings from 'owa-strings/owa-mail-strings';

const enum FilePickerActionMessageType {
    SingleFileTooLarge,
    MultipleFilesTooLarge,
    SingleFileSuggestSharing,
    MultipleFilesSuggestSharing,
    AttachFolder,
    AttachWithoutExtension,
    AttachOneNote,
    AttachGoogleFiles,
    SharePlainText,
    SharePermissions,
    AttachSharedCalendar,
}

export default FilePickerActionMessageType;

export const actionMessageMap: { [filePickerActionMessageType: number]: () => string } = {
    [FilePickerActionMessageType.SingleFileTooLarge]: () => strings.ActionsPanel_SingleFileTooLarge,
    [FilePickerActionMessageType.MultipleFilesTooLarge]: () =>
        strings.ActionsPanel_MultipleFilesTooLarge,
    [FilePickerActionMessageType.SingleFileSuggestSharing]: () =>
        strings.ActionsPanel_SingleFileSuggestSharing,
    [FilePickerActionMessageType.MultipleFilesSuggestSharing]: () =>
        strings.ActionsPanel_MultipleFilesSuggestSharing,
    [FilePickerActionMessageType.AttachFolder]: () => strings.ActionsPanel_AttachFolder,
    [FilePickerActionMessageType.AttachWithoutExtension]: () =>
        strings.ActionsPanel_AttachWithoutExtension,
    [FilePickerActionMessageType.AttachOneNote]: () => strings.ActionsPanel_AttachOneNote,
    [FilePickerActionMessageType.AttachGoogleFiles]: () => strings.ActionsPanel_AttachGoogleFiles,
    [FilePickerActionMessageType.SharePlainText]: () => strings.ActionsPanel_SharePlainText,
    [FilePickerActionMessageType.SharePermissions]: () => strings.ActionsPanel_SharePermissions,
    [FilePickerActionMessageType.AttachSharedCalendar]: () =>
        strings.ActionsPanel_AttachSharedCalendar,
};
